import CountryApi from '../api/CountryApi';
import currencyList from '../currencyList';

const LOCAL_TARGET_CURRENCY_KEY = 'Simcase-WLCC-LocalTargetCurrency';

const getCachedTargetCurrency = () => {
  return window.localStorage.getItem(LOCAL_TARGET_CURRENCY_KEY);
};

const cacheTargetCurrency = (currency) => {
  window.localStorage.setItem(LOCAL_TARGET_CURRENCY_KEY, currency);
};

const detectCurrencyByCountry = async (publicToken) => {
  try {
    const country = await CountryApi.show({ publicToken });

    const currency = currencyList.find(({ countries }) =>
      countries.includes(country.isoCode)
    );

    if (currency) {
      return currency.code;
    }
    return null;
  } catch {
    return null;
  }
};

const isCurrencyPermitted = (currency, config, storeProfile) => {
  const baseCurrency = storeProfile.formatsAndUnits.currency;
  const { currencies } = config;
  return currency === baseCurrency || currencies.includes(currency);
};

const getTargetCurrency = async (appConfig, storeProfile, publicToken) => {
  const { currencies } = appConfig;

  const cachedCurrency = getCachedTargetCurrency();
  if (
    cachedCurrency &&
    isCurrencyPermitted(cachedCurrency, appConfig, storeProfile)
  ) {
    return cachedCurrency;
  }

  const detectedCountryCurrency = await detectCurrencyByCountry(publicToken);
  if (
    detectedCountryCurrency &&
    isCurrencyPermitted(detectedCountryCurrency, appConfig, storeProfile)
  ) {
    return detectedCountryCurrency;
  }

  return currencies[0];
};

export { getTargetCurrency, cacheTargetCurrency };
